module.exports = __webpack_public_path__ + "img/instant_carousel_2.78a118d4.jpg";